import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { PaymentRequest, PaymentRequestStatus } from '@/types/database/payment-requests';

export const useMyPaymentRequests = (status?: PaymentRequestStatus | PaymentRequestStatus[]) => {
  const { user } = useAuth();
  const email = user?.email?.toLowerCase() ?? null;

  return useQuery({
    queryKey: ['my-payment-requests', user?.id, email, status],
    queryFn: async () => {
      if (!user?.id) return [] as PaymentRequest[];

      // Match by requestor_id (signed-in submissions) OR requester_email
      // (submissions made through the public form using the same email).
      const orFilter = email
        ? `requestor_id.eq.${user.id},requester_email.ilike.${email}`
        : `requestor_id.eq.${user.id}`;

      let query = supabase
        .from('payment_requests')
        .select(`
          *,
          department:departments(*),
          category:expense_categories(*),
          approvals:payment_request_approvals(
            id,
            approver_id,
            status,
            approved_at
          ),
          expense:expenses!payment_request_id(
            id,
            net_payment,
            total_amount
          )
        `)
        .or(orFilter)
        .order('created_at', { ascending: false })
        .limit(10000);

      if (status) {
        if (Array.isArray(status)) query = query.in('status', status);
        else query = query.eq('status', status);
      }

      const { data, error } = await query;
      if (error) throw error;
      return data as unknown as PaymentRequest[];
    },
    enabled: !!user?.id,
  });
};
